import { render, staticRenderFns } from "./queryInfo.vue?vue&type=template&id=84cd76b2&scoped=true"
import script from "./queryInfo.vue?vue&type=script&lang=js"
export * from "./queryInfo.vue?vue&type=script&lang=js"
import style0 from "./queryInfo.vue?vue&type=style&index=0&id=84cd76b2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84cd76b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84cd76b2')) {
      api.createRecord('84cd76b2', component.options)
    } else {
      api.reload('84cd76b2', component.options)
    }
    module.hot.accept("./queryInfo.vue?vue&type=template&id=84cd76b2&scoped=true", function () {
      api.rerender('84cd76b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/frontPageManage/configureManage/mobilePreview/components/queryInfo.vue"
export default component.exports